import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../../../../../lib/supabase'
import { reportUnexpectedError } from '../../../../../lib/reportError'

export interface AddCashierInput {
  name: string
  email: string | null
  role: 'staff' | 'manager'
}

export interface AddCashierResult {
  id: string
  pin: string
}

async function addCashier(input: AddCashierInput): Promise<AddCashierResult> {
  const { data, error } = await supabase.functions.invoke<AddCashierResult>('add-cashier', {
    body: input,
  })
  if (error) {
    reportUnexpectedError(error)
    throw error
  }
  if (!data) {
    const failure = new Error('No data returned from add-cashier')
    reportUnexpectedError(failure)
    throw failure
  }
  return data
}

export function useAddCashier() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: addCashier,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['cashiers'] }),
  })
}